import styled from 'styled-components';

import { ItemText } from '@components/ui/search/SearchResultListStyle';

export const ItemErrorText = styled(ItemText)`
  color: ${({ theme }) => theme.palette.tomato};
  font-size: 14px;
`;

export const HotelResponsiveSearchBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
